export default {
  API_ENDPOINT: 'https://spaced-repetition-api-otm.herokuapp.com/api',
  TOKEN_KEY: 'spaced-repetition-jwt-secret',
}
